@use "@/styles/variables" as *;

.bodyModal {
	table {
		margin-bottom: 5px;

		th {
			font-size: 12px;
			font-weight: 500;
			border: none;
			color: $gray-500;
		}

		tr td,
		tr th {
			padding: 5px;
		}
	}
}

.actionContainer {
	margin-top: 20px;
	display: flex;
	justify-content: center;
}

.addOptionButton {
	margin-top: 10px;
}
